import axios from "axios";
import React, { useEffect, useState } from "react";
import { redirect, useNavigate } from "react-router-dom";
import { JwtDecoder } from "../../Utils/JwtDecoder";
import { toast } from "react-toastify";
import base_url from "../../Utils/server";
export function loader({ req }) {
  if (sessionStorage.getItem("jwtToken") == null) {
    throw redirect("/?message=PleaseLogin");
  }
  const Token = sessionStorage.getItem("jwtToken");
  let decoded = JwtDecoder(Token);
  if (!decoded.roles.roleName === "Admin") {
    toast.error("You are not an Admin");
    throw redirect("/home");
  }

  return null;
}
export const Queries = () => {
  const navigate = useNavigate();
  const [queries, setQueries] = useState([]);
  const [ansqueries, setAnsQueries] = useState([]);
  const Token = sessionStorage.getItem("jwtToken");
  useEffect(() => {
    axios
      .get(`${base_url}/contactus/unanswered`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "success") {
          setQueries(res.data.data);
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error fetching Queries");
      });
      
      axios
      .get(`${base_url}/contactus/answered`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "success") {
          setAnsQueries(res.data.data);
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error fetching Queries");
      });
  }, []);

  function handleAnswered(id1) {
    const id = toast.loading("Checking Details...", {
      position: toast.POSITION.TOP_RIGHT,
    });
    axios
      .post(
        `${base_url}/contactus/setasanswered/${id1}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status != "fail") {
          toast.update(id, {
            render: "Query marked as Answered",
            type: "success",
            isLoading: false,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          setTimeout(
            function () {
              toast.update(id, {
                render: res.data.message,
                type: "error",
                isLoading: false,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
            },
            [500]
          );
        }
      })
      .catch((e) => {
        toast.update(id, {
          render: "Network Error",
          type: "error",
          isLoading: false,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      });
  }

  return (
    <section className="mt-12 max-w-screen-lg mx-auto px-4 md:px-8">
      <div>
        <h1 className="text-red-800 text-3xl font-semibold">
          Unanswered Queries
        </h1>
      </div>
      {queries.length==0 && <h3 className="text-red-800 mt-4 text-xl font-semibold">
          No Unanswered Queries
        </h3>}
      <ul className="mt-12 space-y-6">
        {queries.map((item, idx) => (
          <li key={idx} className="bg-white border-2 p-4 shadow-md rounded-md">
            <div>
              <div className="justify-between sm:flex">
                <div className="flex-1">
                  <h2 className="text-xl text-md text-Black-700 font-bold">
                    {item.name}
                  </h2>
                  <h3 className="text-xl font-sm text-cyan-600">
                    {item.subject}
                  </h3>
                  <p className="text-gray-500 mt-2 pr-2">{item.message}</p>
                </div>
                <div className=" mt-5 space-y-4 text-sm sm:mt-0 sm:space-y-2">
                  <a
                    href={"mailto:" + item.email}
                    className="flex items-center text-gray-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M10 16l-6-6 6-6" />
                      <path d="M20 21v-7a4 4 0 0 0-4-4H5" />
                    </svg>
                    <span className="pr-1">Reply </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </a>
                </div>
              </div>
              <button
                onClick={() => {
                  handleAnswered(item.queryId);
                }}
                className="m-2 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
              >
                Mark As Answered
              </button>
            </div>
          </li>
        ))}
      </ul>
      <div>
        <h1 className="mt-10 text-green-800 text-3xl font-semibold">
          Answered Queries
        </h1>
      </div>
      {ansqueries.length==0 && <h3 className="text-green-800 mt-4 text-xl font-semibold">
          No Answered Queries
        </h3>}
      <ul className="mt-8 space-y-6">
        {ansqueries.map((item, idx) => (
          <li key={idx} className="bg-white border-2 p-4 shadow-md rounded-md">
            <div>
              <div className="justify-between sm:flex">
                <div className="flex-1">
                  <h2 className="text-xl text-md text-Black-700 font-bold">
                    {item.name}
                  </h2>
                  <h3 className="text-xl font-sm text-cyan-600">
                    {item.subject}
                  </h3>
                  <p className="text-gray-500 mt-2 pr-2">{item.message}</p>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <button
        onClick={() => {
          navigate("/profile");
        }}
        className="ml-1 mt-6 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
      >
        Back to Profile
      </button>
    </section>
  );
};
